import enLang from './entries/en_US';
import frLang from './entries/fr_FR';
import jaLang from './entries/ja_JP';
import brLang from './entries/pt_BR';
import zhLang from './entries/zh_CN';

const AppLocale = {
    en: enLang,
    zh: zhLang,
    fr: frLang,
    ja: jaLang,
    br: brLang,
};

export default AppLocale;